import React, { useState, Fragment, useEffect } from "react";
import { Paper, Typography, Button, Avatar } from "@material-ui/core";
import { useStyles, CssTextField } from "./classes";

// validation
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { storage } from "../../firebase/firebase";
import { useHistory } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import * as api from "../../api/index.js";

let initialValues = {
  current: "",
  new: "",
  confirm: "",
};

let changeSchema = Yup.object().shape({
  current: Yup.string()
    .required("Password is required!")
    .min(6, "Min length for the password is 6.")
    .max(15, "Max length for the password is 15."),
  new: Yup.string()
    .required("Password is required!")
    .min(6, "Min length for the password is 6.")
    .max(15, "Max length for the password is 15."),
  confirm: Yup.string()
    .required("Password is required!")
    .min(6, "Min length for the password is 6.")
    .max(15, "Max length for the password is 15."),
});

let passSchema = Yup.object().shape({
  new: Yup.string()
    .required("Password is required!")
    .min(6, "Min length for the password is 6.")
    .max(15, "Max length for the password is 15."),
  confirm: Yup.string()
    .required("Password is required!")
    .min(6, "Min length for the password is 6.")
    .max(15, "Max length for the password is 15."),
});

let infoSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("First Name is required!")
    .max(15, "Max length for the password is 15."),
  lastName: Yup.string()
    .required("Last Name is required!")
    .max(15, "Max length for the password is 15."),
});

const EditInformation = () => {
  const classes = useStyles();
  const history = useHistory();
  const [isSuccess, setIsSuccess] = useState(false);
  const [isPass, setIsPass] = useState(false);
  const [isFalse, setIsFalse] = useState(false);
  const [isSuccessPass, setIsSuccessPass] = useState(false);
  const [isFalsePass, setIsFalsePass] = useState(false);
  const [isErrorPass, setIsErrorPass] = useState(false);
  const [defaultImageUpload, setDefaultImageUpload] = useState(false);
  const checkUpdates = JSON.parse(localStorage.getItem("userUpdate"));
  const nuser = JSON.parse(sessionStorage.getItem("profile"));

  useEffect(() => {
    fetchResults();
    if (checkUpdates) {
      localStorage.removeItem("userUpdate");
    }
    // eslint-disable-next-line
  }, [checkUpdates, nuser]);

  const [initialValues2, setInitialValues2] = useState({
    firstName: "",
    lastName: "",
    image: "",
  });

  const fetchResults = async () => {
    try {
      const { data } = await api.getDetails();
      
      if (data.local.password) {
        setIsPass(true);
      }
      setInitialValues2({
        ...initialValues2,
        firstName: data.local.firstName,
        lastName: data.local.lastName,
        image: data.displayPicture,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const submit = async (e, { resetForm }) => {
    try {
      if (e.new === e.confirm) {
        const formData = { oldPassword: e.current, password: e.confirm };
    

        const { data } = await api.changePassword(formData);
        if (data) {
          setIsSuccessPass(true);
          setTimeout(() => {
            setIsSuccessPass(false);
          }, 3000);
        }

        resetForm();
      } else {
        setIsFalsePass(true);
        setTimeout(() => {
          setIsFalsePass(false);
        }, 3000);
      }
    } catch (error) {
      if (error.response.status === 401) {
        setIsErrorPass(true);
        setTimeout(() => {
          setIsErrorPass(false);
        }, 3000);
      }
    }
  };

  const changeNames = async (e) => {
    try {
      if (e.image) {
        const formData = {
          displayPicture: e.image,
          firstName: e.firstName,
          lastName: e.lastName,
        };
        const { data } = await api.updateUser(formData);

        if (data) {
          setIsSuccess(true);
          setTimeout(() => {
            setIsSuccess(false);
          }, 3000);
          localStorage.setItem("userUpdate", JSON.stringify({ formData }));
          history.push("/dashboard");
        } else {
          setIsFalse(true);
          setTimeout(() => {
            setIsFalse(false);
          }, 3000);
        }
      } else {
        const formData1 = {
          displayPicture: " ",
          firstName: e.firstName,
          lastName: e.lastName,
        };
        const { data } = await api.updateUser(formData1);

        if (data) {
          setIsSuccess(true);
          setTimeout(() => {
            setIsSuccess(false);
          }, 3000);
          localStorage.setItem("userUpdate", JSON.stringify({ formData1 }));
          history.push("/dashboard");
        } else {
          setIsFalse(true);
          setTimeout(() => {
            setIsFalse(false);
          }, 3000);
        }
      }
    } catch (error) {
      setIsFalse(true);
      setTimeout(() => {
        setIsFalse(false);
      }, 3000);
    }
  };

  const handleImageAsFile = async (e, setFieldValue, type, values) => {
    try {
      setDefaultImageUpload(true);
      const image = e.target.files[0];
      const storageRef = storage.ref();
      const fileRef = storageRef.child(`dish/${image.name}`);
      const uploadTaskSnapshot = await fileRef.put(image);
      const imageUrl = await uploadTaskSnapshot.ref.getDownloadURL();

      // if (type === "logo") {
      //   setFieldValue("logo", imageUrl);
      // } else {
      //   setFieldValue(`images[${values.images.length}]`,imageUrl)
      // }

      setFieldValue("image", imageUrl);

      // setArtWorkUpload(imageUrl);
    } catch (error) {
      console.error(error);
    } finally {
      setDefaultImageUpload(false);
    }
    // setImageAsFile(imageFile => (image))
  };

  return (
    <>
      <div>
        <Typography className={classes.editInfo}>Edit Information</Typography>

        <Paper className={classes.account}>
          <Formik
            initialValues={initialValues2}
            onSubmit={changeNames}
            validationSchema={infoSchema}
            enableReinitialize
          >
            {({
              dirty,
              isValid,
              handleBlur,
              values,
              setFieldValue,
              resetForm,
            }) => {
              return (
                <Form>
                  <div className={classes.displayRow}>
                    <div className={classes.divide}>
                      <Typography className={classes.forms}>
                        Account Information
                      </Typography>
                      <div className={classes.displayFlex}>
                        <Typography className={classes.fieldText1}>
                          First Name &nbsp;&nbsp; &nbsp;
                        </Typography>

                        <Field
                          name="firstName"
                          placeholder="  First Name"
                          component={CssTextField}
                          className={classes.field}
                          variant="outlined"
                        ></Field>
                      </div>
                      <div className={classes.displayFlex}>
                        <Typography className={classes.fieldText1}>
                          Last Name &nbsp;&nbsp; &nbsp;
                        </Typography>

                        <Field
                          name="lastName"
                          placeholder="  Last Name"
                          component={CssTextField}
                          className={classes.field}
                          variant="outlined"
                        ></Field>
                      </div>
                    </div>

                    <div
                      className={classes.divide}
                      style={{ marginTop: 30, marginBottom: 30 }}
                    >
                      {defaultImageUpload ? (
                        "Uploading..."
                      ) : (
                        <Fragment>
                          <div className={classes.imageDirection}>
                            <Avatar
                              src={values.image ? values.image : ""}
                              variant="square"
                              className={classes.image}
                            ></Avatar>

                            <div>
                              <label htmlFor="upload-photo">
                                <input
                                  style={{ display: "none" }}
                                  id="upload-photo"
                                  name="upload-photo"
                                  type="file"
                                  accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                                  onChange={(e) => {
                                    e.persist();
                                    handleImageAsFile(
                                      e,
                                      setFieldValue,
                                      "image",
                                      values
                                    );
                                  }}
                                />

                                <Button
                                  variant="contained"
                                  component="span"
                                  className={classes.upload}
                                >
                                  Upload
                                </Button>
                              </label>
                            </div>
                          </div>
                        </Fragment>
                      )}
                    </div>
                  </div>

                  {isSuccess && (
                    <>
                      <Alert
                        icon={false}
                        onClose={() => {}}
                        className={classes.alert}
                        severity="success"
                      >
                        User updated successfully!
                      </Alert>
                    </>
                  )}

                  {isFalse && (
                    <>
                      <Alert
                        icon={false}
                        onClose={() => {}}
                        className={classes.alert}
                        severity="error"
                      >
                        Un Authorized User!
                      </Alert>
                    </>
                  )}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignContent: "space-between",
                      alignItems: "space-between",
                    }}
                  >
                    <Button
                      variant="contained"
                      className={classes.clear}
                      onClick={resetForm}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      className={classes.button}
                      disabled={!dirty || !isValid}
                      type="submit"
                    >
                      save
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>

          <br />
        </Paper>

        <Paper className={classes.change}>
          <Typography className={classes.changePas}>Change Password</Typography>

          <Formik
            initialValues={initialValues}
            onSubmit={submit}
            validationSchema={isPass ? changeSchema : passSchema}
          >
            {({ dirty, isValid, resetForm }) => {
              return (
                <Form>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div className={classes.divide}>
                      {isPass && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Typography className={classes.fieldText2}>
                            Current Password &nbsp;
                          </Typography>

                          <Field
                            name="current"
                            placeholder="  Current Password"
                            component={CssTextField}
                            className={classes.field}
                            type="password"
                            variant="outlined"
                          ></Field>
                        </div>
                      )}

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography className={classes.fieldText2}>
                          New Password
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </Typography>

                        <Field
                          name="new"
                          placeholder="  New Password"
                          component={CssTextField}
                          className={classes.field}
                          type="password"
                          variant="outlined"
                        ></Field>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography className={classes.fieldText2}>
                          Confirm Password &nbsp;
                        </Typography>

                        <Field
                          name="confirm"
                          placeholder="  Confirm Password"
                          component={CssTextField}
                          className={classes.field}
                          type="password"
                          variant="outlined"
                        ></Field>
                      </div>
                    </div>
                  </div>
                  {isSuccessPass && (
                    <>
                      <Alert
                        icon={false}
                        onClose={() => {}}
                        className={classes.alert}
                        severity="success"
                      >
                        Updated Password successfully!
                      </Alert>
                    </>
                  )}

                  {isFalsePass && (
                    <>
                      <Alert
                        icon={false}
                        onClose={() => {}}
                        className={classes.alert}
                        severity="error"
                      >
                        Password Mismatch
                      </Alert>
                    </>
                  )}

                  {isErrorPass && (
                    <>
                      <Alert
                        icon={false}
                        onClose={() => {}}
                        className={classes.alert}
                        severity="error"
                      >
                        Wrong Current Password
                      </Alert>
                    </>
                  )}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignContent: "space-between",
                      alignItems: "space-between",
                    }}
                  >
                    <Button
                      variant="contained"
                      className={classes.clear}
                      onClick={resetForm}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      className={classes.button}
                      disabled={!dirty || !isValid}
                      type="submit"
                    >
                      save
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>

          <br />
        </Paper>
      </div>
    </>
  );
};

export default EditInformation;
